export const isValidPhone = (value: string) => {
  if (value.trim() === "") {
    return false;
  }

  if (!/[0-9]{10,}/.test(value)) {
    return false;
  }

  return true;
};

export const getPhoneValue = (value: string) => {
  const numberValue = value
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  if (numberValue) return numberValue[0];
};
